import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";
import { Tooltip } from "primereact/tooltip";

interface UsageSummaryProps {
  levels?: { name: string | null; consumed: number | null }[];
  totalConsumed?: number;
  isLoading?: boolean;
}

const UsageSummary: React.FC<UsageSummaryProps> = ({
  levels = [],
  totalConsumed = 0,
  isLoading = false,
}) => {
  const displayLevels = isLoading
    ? Array(7)
        .fill(null)
        .map(() => ({ name: null, consumed: null }))
    : levels;

  return (
    <Card>
      <h2 className="mb-4">Usage Summary</h2>
      <DataTable
        value={displayLevels}
        className="p-datatable-sm"
        tableClassName="dt-responsive-text"
        aria-label="Usage by level"
        emptyMessage="No usage data available."
      >
        <Column
          field="name"
          header="Level"
          body={rowData =>
            rowData.name === null ? <Skeleton className="min-h-6" /> : rowData.name
          }
        />
        <Column
          field="consumed"
          header={
            <>
              <Tooltip
                target="#consumed-header-tooltip"
                content='A lesson is considered "consumed" as soon as it is launched.'
                position="top"
              />
              <span id="consumed-header-tooltip">Lessons Consumed</span>
            </>
          }
          body={rowData =>
            rowData.consumed === null ? <Skeleton className="min-h-6" /> : rowData.consumed
          }
        />
      </DataTable>
      <div className="flex justify-end font-semibold mt-2">
        <p className="mr-2">Total Consumed:</p>{" "}
        {isLoading ? <Skeleton className="max-w-16 h-6" /> : totalConsumed}
      </div>
    </Card>
  );
};

export default UsageSummary;
